import { cva } from "class-variance-authority";

export type NpsRatingBucket = "detractor" | "passive" | "promoter";

export const NPS_COLOR_DETRACTOR = "#D73F3D";
export const NPS_COLOR_PASSIVE = "#ED9929";
export const NPS_COLOR_PROMOTER = "#008735";

export const NPS_RATING_SCALE_ROW_MAX_WIDTH = 712;

export function getNpsRatingBucket(value: number): NpsRatingBucket {
  if (value <= 6) return "detractor";
  if (value <= 8) return "passive";
  return "promoter";
}

export const npsRatingScaleScrollStyles = cva([
  "w-full overflow-x-auto pb-1",
]);

export const npsRatingScaleRootStyles = cva([
  "mx-auto flex min-w-max flex-row items-center justify-center gap-2",
]);

export const npsRatingScaleMobileRootStyles = cva([
  "flex flex-col md:hidden",
]);

export const npsRatingScaleMobileRowStyles = cva([
  "grid grid-cols-5 gap-2",
]);

export const npsRatingScaleMobileLabelRowStyles = cva([
  "grid grid-cols-5 gap-2",
]);

export const npsRatingScaleMobileLowLabelRowStyles = cva([
  "mb-2",
]);

export const npsRatingScaleMobileHighLabelRowStyles = cva([
  "mt-2",
]);

export const npsRatingScaleMobileLowLabelStyles = cva([
  "col-span-2 block text-left",
  "font-[Poppins,sans-serif] text-xs font-normal leading-4 tracking-[0.4px] text-[#44474C]",
]);

export const npsRatingScaleMobileHighLabelStyles = cva([
  "col-start-5 block text-right",
  "font-[Poppins,sans-serif] text-xs font-normal leading-4 tracking-[0.4px] text-[#44474C]",
]);

export const npsRatingScaleMobileSecondRowStyles = cva([
  "mt-4",
]);

export const npsRatingOptionStyles = cva(
  [
    "flex items-center justify-center rounded-full border-2",
    "text-base font-medium leading-6",
    "font-[Poppins,sans-serif] transition-colors",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
    "cursor-pointer select-none",
  ],
  {
    variants: {
      layout: {
        mobile: "aspect-square w-full max-h-16 max-w-16 justify-self-center",
        desktop: "size-16 shrink-0 aspect-square",
        responsive:
          "aspect-square w-full max-h-16 max-w-16 justify-self-center md:size-16 md:max-h-none md:max-w-none md:shrink-0",
      },
      bucket: {
        detractor: "border-[#D73F3D]",
        passive: "border-[#ED9929]",
        promoter: "border-[#008735]",
      },
      selected: {
        true: "text-white",
        false: "bg-white text-[#1B1C1D]",
      },
    },
    compoundVariants: [
      {
        bucket: "detractor",
        selected: true,
        className: "border-[#D73F3D] bg-[#D73F3D]",
      },
      {
        bucket: "passive",
        selected: true,
        className: "border-[#ED9929] bg-[#ED9929]",
      },
      {
        bucket: "promoter",
        selected: true,
        className: "border-[#008735] bg-[#008735]",
      },
    ],
    defaultVariants: {
      layout: "desktop",
      selected: false,
    },
  },
);

export const npsRatingScaleLabelsStyles = cva([
  "mx-auto mt-3 hidden w-full max-w-[712px] items-start justify-between gap-2 md:flex",
  "font-[Poppins,sans-serif] text-xs font-normal leading-4 tracking-[0.4px] text-[#44474C]",
]);
